import http, { url } from '../../http'

const API_URL = "monitoring_objectives_sgosh"

class monitoring_objetivesAPI {

  async save(monitoring) {
    const response = await http(`${API_URL}/save`, 'POST', monitoring)
    return response
  }
 
  async getAllIobjetives() {
    const response = await http(`${API_URL}`)
    return response
  }  

  async getAllmonitoring(id,  page) {
    const response = await http(`${API_URL}/objectiveId/${id} ?page=${page}`, 'POST')
    return response
  } 
 
  async getSeguimiento(id) {
    const response = await http(`${API_URL}/show/${id}`)
    return response
  }

  async update(id, seguimiento) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', seguimiento)
    return response
  }
 
  async deleteIdentification(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }
  
}

export default new monitoring_objetivesAPI()